module.exports = __webpack_public_path__ + "static/elizabeth-tatler-938a868672e52209cba2055e609042ee.avif";